// `Window.hj` is declared by @lmn/contenthub-types as an optional `(...args: unknown[]) => void`.
// A second global declaration here would have to match that one exactly, so the queue the Hotjar
// stub hangs off the function is typed locally instead of widening the global.
type HotjarStub = ((...args: unknown[]) => void) & { q?: unknown[] };

export enum HotjarEvent {
  EVO_RESULTS = 'TSX_EVO_RESULTS',
  EVO_DETAILS = 'TSX_EVO_DETAILS',
  EVO_FLIGHT = 'TSX_EVO_FLIGHT',
  EVO_RESULTS_APEX = 'TSX_EVO_RESULTS_APEX',
  EVO_DETAILS_APEX = 'TSX_EVO_DETAILS_APEX',
}

const init = () => {
  if (window.hj) return;

  const stub: HotjarStub = (...args: unknown[]) => {
    (stub.q = stub.q || []).push(args);
  };
  window.hj = stub;
};

export const hotjarEvents = (eventNames: HotjarEvent[]) => {
  init();
  eventNames.forEach((name) => window.hj?.('event', name));
};
